export function populateDropdownsFromURL() {
  // Parse the URL parameters
  const urlParams = new URLSearchParams(window.location.search);

  // Get the department and position from the URL
  const department = urlParams.get("department");
  const position = urlParams.get("position");

  let shouldClickButton = false;

  // Set the department dropdown
  if (department) {
    const departmentSelect = document.getElementById("query-0-departments");
    if (departmentSelect) {
      departmentSelect.value = department;
      shouldClickButton = true;
    }
  }

  // Set the position dropdown
  if (position) {
    const positionSelect = document.getElementById("query-0-positions");
    if (positionSelect) {
      positionSelect.value = position;
      shouldClickButton = true;
    }
  }

  // Only click the "Apply Filters" button if a parameter was set
  if (shouldClickButton) {
    const applyFiltersButton = document.querySelector(".fndry-advanced-filters__btn-apply");
    if (applyFiltersButton) {
      applyFiltersButton.click();
    }
  }
}

// Automatically run the function when the DOM is fully loaded
document.addEventListener("DOMContentLoaded", populateDropdownsFromURL);
